import type { PublicApiKey } from '@/apilib';
import type { createPreviewApi } from './previewWrapper';

export const PreviewApiKey: PublicApiKey<typeof createPreviewApi> = {
  name: 'PreviewApi',
  public: true,
};
